'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import getComponentName from 'react-utils/getComponentName';
import { jsx as _jsx } from "react/jsx-runtime";
const withTinyMcePopoverLifecycle = WrappedComponent => {
  class TinyMcePopoverLifecycle extends Component {
    constructor(props) {
      super(props);
      this.handleEditorBlur = this.handleEditorBlur.bind(this);
      this.handleEditorRemove = this.handleEditorRemove.bind(this);
      this.blurEvents = props.editor.settings.blurEvents ? ['blur', props.editor.settings.blurEvents].join(' ') : 'blur';
    }
    componentDidMount() {
      const {
        onRemove,
        editor
      } = this.props;

      // When TinyMCE is is in inline mode, the popover and the target are rendered in the same
      // window so we don't have to worry about the target being masked by the parent window
      if (!editor.settings.inline) {
        // Toolbar components are rendered before the editor is setup - need to wait to add the events
        // if the editor's window is not yet available
        if (editor.getWin()) {
          editor.getWin().addEventListener('scroll', onRemove);
        } else {
          editor.on('init', () => {
            editor.getWin().addEventListener('scroll', onRemove);
          });
        }
      }

      // Add remove handler to the front of the event queue
      // so that the handler is more likely to run before the
      // iframe is destroyed
      editor.on('remove', this.handleEditorRemove, true);
      // if this event is running on a button click in safari/ff put a event.preventDefault on the
      // onMouseDown event.
      editor.on(this.blurEvents, this.handleEditorBlur);
    }
    componentWillUnmount() {
      const {
        onRemove,
        editor
      } = this.props;
      if (!editor.removed) {
        editor.getWin().removeEventListener('scroll', onRemove);
        editor.off('remove', this.handleEditorRemove);
        editor.off(this.blurEvents, this.handleEditorBlur);
      }
    }
    handleEditorBlur() {
      const {
        onRemove
      } = this.props;
      setTimeout(onRemove);
    }
    handleEditorRemove() {
      const {
        onRemove,
        editor
      } = this.props;
      if (!editor.settings.inline && editor.getWin() && editor.getWin().removeEventListener) {
        editor.getWin().removeEventListener('scroll', onRemove);
      }
      onRemove();
    }
    render() {
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
        className: "mce-hubspot-popover",
        pinToConstraint: ['left', 'right', 'top', 'bottom']
      }, this.props));
    }
  }
  TinyMcePopoverLifecycle.propTypes = {
    editor: PropTypes.object.isRequired,
    onRemove: PropTypes.func
  };
  TinyMcePopoverLifecycle.defaultProps = {
    onRemove: () => {}
  };
  TinyMcePopoverLifecycle.displayName = `TinyMcePopoverLifecycle(${getComponentName(WrappedComponent)})`;
  return TinyMcePopoverLifecycle;
};
export default withTinyMcePopoverLifecycle;